/* Component Dependencies */
var destinationMetaTileTemplate = require('templates/destinationMetaTile.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
    type: 'destinationMetaTile',
    template: {
        'destinationMetaTile': destinationMetaTileTemplate
    }
});